(function(){
  var root = document.getElementById('ch-drawer');
  if(!root) return;
  var panel = root.querySelector('.ch-dw__panel');
  var lines = root.querySelector('[data-dw-lines]');
  var sub = root.querySelector('[data-dw-sub]');
  var subwas = root.querySelector('[data-dw-subwas]');
  var freeEl = root.querySelector('[data-dw-free]');
  var shipZone = root.querySelector('[data-dw-shipzone]');
  var shipTxt = root.querySelector('[data-dw-shiptxt]');
  var fill = root.querySelector('[data-dw-fill]');
  var co = root.querySelector('[data-dw-co]');
  var upWrap = root.querySelector('[data-dw-up]');
  var protBtn = root.querySelector('[data-dw-prot]');
  var protZone = root.querySelector('.ch-dw__prot');
  var EMPTY = root.getAttribute('data-empty') || 'Your cart is empty.';
  var THRESH = parseInt(root.getAttribute('data-threshold') || '0', 10);
  var T_AWAY = root.getAttribute('data-away') || '[amount] away from free shipping';
  var T_WON = root.getAttribute('data-won') || 'Free shipping unlocked!';
  var T_START = root.getAttribute('data-start') || 'Spend [amount] for free shipping';
  var FREE_ON = root.getAttribute('data-freeon') || 'Free shipping included';
  var FREE_OFF = root.getAttribute('data-freeoff') || 'Shipping calculated at checkout';
  var GIFT_WORD = root.getAttribute('data-giftword') || 'Gift';
  var FMT = root.getAttribute('data-money') || '${{amount}}';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"></path></svg>';
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 6h11v9H1z"></path><path d="M12 9h5l3 3v3h-8z"></path><circle cx="5.5" cy="18" r="1.8"></circle><circle cx="16.5" cy="18" r="1.8"></circle></svg>';
  var TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"></path><path d="M8 6V4h8v2"></path><path d="M19 6l-1 14H6L5 6"></path><path d="M10 11v5M14 11v5"></path></svg>';
  var openedAt = 0, wasWon = false, closeTmr = null;
  var pCache = {};
  var reconciling = false;

  var st = document.createElement('style');
  st.textContent =
    '#ch-drawer .ch-dw__rm{flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;padding:0;border:1px solid var(--ch-line,#e2e8e3);border-radius:8px;background:#fff;color:#8b959a;cursor:pointer}' +
    '#ch-drawer .ch-dw__rm svg{width:16px;height:16px}' +
    '#ch-drawer .ch-dw__rm:hover{color:#c0392b;border-color:#e8c9c4}' +
    '#ch-drawer .ch-dw__acts{display:flex;align-items:center;gap:8px}' +
    '#ch-drawer .ch-dw__lp--gift{display:flex;flex-direction:column;align-items:flex-end;gap:1px;line-height:1.2}' +
    '#ch-drawer .ch-dw__giftw{font-weight:800;letter-spacing:.02em;color:#1f9d55}' +
    '#ch-drawer .ch-dw__giftwas{font-size:11.5px;font-weight:400;color:#8b959a;text-decoration:line-through}' +
    '#ch-drawer .ch-dw__giftwas:empty{display:none}' +
    '#ch-drawer .ch-dw__lwas{font-size:11.5px;font-weight:400;color:#8b959a;text-decoration:line-through;margin-left:6px}' +
    '#ch-drawer .ch-dw__lwas:empty{display:none}';
  document.head.appendChild(st);

  function money(cents){
    var n = (cents/100).toFixed(2);
    return FMT.replace(/\{\{\s*amount\s*\}\}/, n)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents/100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(cents/100)));
  }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
    return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
  }); }
  function isGift(l){ return l.price === 0; }

  /* Gift rules recorded by the product pages: which variant unlocks at which
     quantity of which product. Keeps the cart from ever holding an orphan gift. */
  function rules(){
    try { return JSON.parse(localStorage.getItem('ch_gift_rules') || '{}'); }
    catch(e){ return {}; }
  }
  function reconcile(cart){
    if(reconciling) return Promise.resolve(null);
    var map = rules();
    var pids = Object.keys(map);
    if(!pids.length) return Promise.resolve(null);

    var items = cart.items || [];
    var qtyByProduct = {}, qtyByVariant = {};
    items.forEach(function(l){
      qtyByProduct[String(l.product_id)] = (qtyByProduct[String(l.product_id)] || 0) + l.quantity;
      qtyByVariant[String(l.variant_id)] = (qtyByVariant[String(l.variant_id)] || 0) + l.quantity;
    });

    var updates = {}, adds = [], touched = false;
    pids.forEach(function(pid){
      var set = map[pid] || {};
      var owned = qtyByProduct[pid] || 0;
      (set.gifts || []).forEach(function(g){
        var vid = String(g.vid);
        var have = qtyByVariant[vid] || 0;
        var want = (owned > 0 && owned >= g.need) ? 1 : 0;
        if(have === want) return;
        touched = true;
        if(want === 0) updates[vid] = 0;
        else if(have === 0) adds.push({ id: parseInt(vid, 10), quantity: 1 });
        else updates[vid] = 1;
      });
    });
    if(!touched) return Promise.resolve(null);

    reconciling = true;
    var chain = Promise.resolve();
    if(adds.length){
      chain = chain.then(function(){
        return fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: adds })
        }).catch(function(){});
      });
    }
    if(Object.keys(updates).length){
      chain = chain.then(function(){
        return fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).catch(function(){});
      });
    }
    return chain.then(function(){
      return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.json(); });
    }).then(function(c){ reconciling = false; return c; }, function(){ reconciling = false; return null; });
  }

  function open(){
    if(closeTmr){ clearTimeout(closeTmr); closeTmr = null; }
    root.classList.add('is-mounted');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){ root.classList.add('is-open'); openedAt = Date.now(); });
    });
  }
  function close(){
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    closeTmr = setTimeout(function(){ root.classList.remove('is-mounted'); closeTmr = null; }, 360);
  }
  function isOpen(){ return root.classList.contains('is-open'); }
  function busy(on){ root.classList.toggle('is-busy', !!on); }

  function counts(n){
    document.querySelectorAll('[data-ch-count]').forEach(function(el){ el.textContent = n; });
    document.querySelectorAll('.cart-count-bubble span:first-child').forEach(function(el){ el.textContent = n; });
    var btn = document.querySelector('.ch-hd__cart');
    if(btn){ btn.classList.remove('is-bump'); void btn.offsetWidth; btn.classList.add('is-bump'); }
  }

  var protPid = protBtn ? protBtn.getAttribute('data-dw-protpid') : null;
  var protLine = 0;

  function loadProducts(items){
    var handles = [];
    items.forEach(function(l){ if(l.handle && handles.indexOf(l.handle) === -1) handles.push(l.handle); });
    return Promise.all(handles.map(function(h){
      if(Object.prototype.hasOwnProperty.call(pCache, h)) return Promise.resolve();
      return fetch(ROOT + 'products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(p){ pCache[h] = p; })
        .catch(function(){ pCache[h] = null; });
    }));
  }
  function compareFor(l){
    var p = pCache[l.handle];
    if(p && p.variants){
      for(var i = 0; i < p.variants.length; i++){
        if(p.variants[i].id === l.variant_id) return p.variants[i].compare_at_price || null;
      }
    }
    return null;
  }

  function render(cart){
    var items = cart.items || [];
    counts(cart.item_count);

    protLine = 0;
    var visible = [];
    items.forEach(function(l, i){
      l.__line = i + 1;
      if(protPid && String(l.product_id) === protPid){ protLine = i + 1; return; }
      visible.push(l);
    });
    visible.sort(function(a, b){ return b.final_line_price - a.final_line_price; });

    if(!visible.length){
      lines.innerHTML = '<div class="ch-dw__empty">' + esc(EMPTY) + '</div>';
    } else {
      lines.innerHTML = visible.map(function(l){
        var idx = l.__line;
        var gift = isGift(l);
        var img = l.image ? l.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
        var opts = (l.options_with_values || []).map(function(o){ return o.value; })
          .filter(function(v){ return v && v !== 'Default Title'; }).join(' / ');
        var rm = '<button type="button" class="ch-dw__rm" data-dw-chg="' + idx + '" data-dw-to="0" aria-label="Remove">' + TRASH + '</button>';
        var actions = gift
          ? '<div class="ch-dw__acts">' + rm + '</div>'
          : '<div class="ch-dw__acts">' +
              '<div class="ch-dw__stp">' +
                '<button type="button" data-dw-chg="' + idx + '" data-dw-to="' + (l.quantity - 1) + '" aria-label="Decrease">−</button>' +
                '<span>' + l.quantity + '</span>' +
                '<button type="button" data-dw-chg="' + idx + '" data-dw-to="' + (l.quantity + 1) + '" aria-label="Increase">+</button>' +
              '</div>' + rm +
            '</div>';
        var price = gift
          ? '<div class="ch-dw__lp ch-dw__lp--gift">' +
              '<span class="ch-dw__giftw">' + esc(GIFT_WORD) + '</span>' +
              '<s class="ch-dw__giftwas" data-dw-giftwas="' + idx + '"></s>' +
            '</div>'
          : '<div class="ch-dw__lp">' + money(l.final_line_price) + '<s class="ch-dw__lwas" data-dw-lwas="' + idx + '"></s></div>';
        return '<div class="ch-dw__line">' +
          (img ? '<img src="' + esc(img) + '" alt="" width="62" height="62">' : '') +
          '<div class="ch-dw__lb">' +
            '<div class="ch-dw__ln">' + esc(l.product_title) + '</div>' +
            (opts ? '<div class="ch-dw__lv">' + esc(opts) + '</div>' : '') +
            '<div class="ch-dw__lrow">' + actions + price + '</div>' +
          '</div>' +
        '</div>';
      }).join('');
    }

    if(sub) sub.textContent = money(cart.total_price);
    if(co) co.disabled = !items.length;

    if(subwas) subwas.innerHTML = '';

    if(items.length){
      loadProducts(items).then(function(){
        visible.forEach(function(l){
          if(isGift(l)){
            var gel = lines.querySelector('[data-dw-giftwas="' + l.__line + '"]');
            if(gel){
              var gca = compareFor(l);
              gel.textContent = gca ? money(gca * l.quantity) : '';
            }
            return;
          }
          var wel = lines.querySelector('[data-dw-lwas="' + l.__line + '"]');
          if(!wel) return;
          /* Prefer the product's real compare-at price (its normal, no-discount price)
             times the quantity in the cart — this is what "buy N of these with no
             discount" should cost. Fall back to Shopify's own pre-line-discount total
             (original_line_price) only when the product has no compare-at price set,
             so a discount code applied at checkout still shows a struck price. */
          var ca = compareFor(l);
          var full = (ca && ca > l.price) ? (ca * l.quantity)
            : (l.original_line_price > l.final_line_price ? l.original_line_price : 0);
          wel.textContent = (full > l.final_line_price) ? money(full) : '';
        });
        if(subwas){
          var full = 0;
          items.forEach(function(l){
            var ca = compareFor(l);
            full += ((ca && ca > l.price) ? ca : l.price) * l.quantity;
          });
          var baseline = Math.max(full, cart.original_total_price || 0);
          if(baseline > cart.total_price) subwas.innerHTML = '<s>' + money(baseline) + '</s>';
        }
      });
    }

    var won = items.length > 0 && THRESH > 0 && cart.total_price >= THRESH;

    if(freeEl){
      if(!items.length){ freeEl.innerHTML = ''; }
      else if(won || THRESH === 0){ freeEl.className = 'ch-dw__free'; freeEl.innerHTML = TICK + '<span>' + esc(FREE_ON) + '</span>'; }
      else { freeEl.className = 'ch-dw__free is-off'; freeEl.innerHTML = TRUCK + '<span>' + esc(FREE_OFF) + '</span>'; }
    }

    if(protBtn){
      protBtn.setAttribute('aria-checked', protLine ? 'true' : 'false');
      if(protZone) protZone.hidden = !visible.length;
    }

    if(THRESH > 0 && shipZone && shipTxt && fill){
      var left = THRESH - cart.total_price;
      if(!items.length){
        shipTxt.textContent = T_START.replace('[amount]', money(THRESH));
        fill.style.width = '0%';
      } else if(!won){
        shipTxt.textContent = T_AWAY.replace('[amount]', money(left));
        fill.style.width = Math.min(100, (cart.total_price / THRESH) * 100) + '%';
      } else {
        shipTxt.textContent = T_WON;
        fill.style.width = '100%';
      }
      if(won && !wasWon){
        shipZone.classList.remove('is-won');
        void shipZone.offsetWidth;
        shipZone.classList.add('is-won');
      } else if(!won){
        shipZone.classList.remove('is-won');
      }
      wasWon = won;
    }

    if(upWrap){
      var inCart = {};
      items.forEach(function(l){ inCart[String(l.product_id)] = true; });
      var any = false;
      upWrap.querySelectorAll('[data-dw-upid]').forEach(function(el){
        var ids = el.getAttribute('data-dw-upid').split(',').filter(Boolean);
        var hit = ids.some(function(pid){ return inCart[pid]; });
        el.hidden = !!hit;
        if(!hit) any = true;
      });
      upWrap.hidden = !any || !visible.length;
    }
  }

  function fetchCart(){
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        return reconcile(c).then(function(fixed){
          var out = fixed || c;
          render(out);
          return out;
        });
      });
  }

  function add(items){
    busy(true);
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(r){
      if(!r.ok) return r.json().then(function(e){ throw new Error(e.description || 'Could not add to cart.'); });
      return r.json();
    }).then(function(){ return fetchCart(); })
      .then(function(c){ busy(false); open(); return c; })
      .catch(function(e){ busy(false); alert(e.message || 'Could not add to cart.'); throw e; });
  }

  function change(line, qty){
    busy(true);
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function(r){ return r.json(); })
      .then(function(){ return fetchCart(); })
      .then(function(){ busy(false); })
      .catch(function(){ busy(false); });
  }

  root.addEventListener('click', function(e){
    if(e.target.closest('[data-dw-close]')){ close(); return; }

    var chg = e.target.closest('[data-dw-chg]');
    if(chg){ change(parseInt(chg.getAttribute('data-dw-chg'),10), parseInt(chg.getAttribute('data-dw-to'),10)); return; }

    var tgl = e.target.closest('[data-dw-prot]');
    if(tgl){
      var on = tgl.getAttribute('aria-checked') === 'true';
      tgl.setAttribute('aria-checked', on ? 'false' : 'true');
      busy(true);
      if(on && protLine){
        change(protLine, 0).then(function(){ busy(false); });
      } else if(!on){
        fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(tgl.getAttribute('data-dw-prot'),10), quantity: 1 }] })
        }).then(function(){ return fetchCart(); }).then(function(){ busy(false); })
          .catch(function(){ busy(false); tgl.setAttribute('aria-checked','false'); });
      } else { busy(false); }
      return;
    }

    var up = e.target.closest('[data-dw-add]');
    if(up){
      var code = up.getAttribute('data-dw-code');
      up.disabled = true;
      add([{ id: parseInt(up.getAttribute('data-dw-add'),10), quantity: 1 }]).then(function(){
        up.disabled = false;
        if(code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + ROOT + 'cart';
      }, function(){ up.disabled = false; });
      return;
    }

    var upm = e.target.closest('[data-dw-addmulti]');
    if(upm){
      var codem = upm.getAttribute('data-dw-code');
      var ids = upm.getAttribute('data-dw-addmulti').split(',').filter(Boolean).map(function(id){ return { id: parseInt(id,10), quantity: 1 }; });
      upm.disabled = true;
      add(ids).then(function(){
        upm.disabled = false;
        if(codem) window.location.href = '/discount/' + encodeURIComponent(codem) + '?redirect=' + ROOT + 'cart';
      }, function(){ upm.disabled = false; });
      return;
    }

    if(e.target.closest('[data-dw-co]')){ window.location.href = ROOT + 'checkout'; return; }
  });

  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && isOpen()) close(); });

  document.addEventListener('click', function(e){
    var opener = e.target.closest('a[href$="/cart"], a[href*="/cart?"], #cart-icon-bubble, [data-ch-opencart]');
    if(opener){ e.preventDefault(); open(); fetchCart(); return; }
    if(isOpen() && Date.now() - openedAt > 250 && panel && !panel.contains(e.target)) close();
  }, true);

  window.CHCart = { open: open, close: close, add: add, refresh: fetchCart };
  fetchCart();
})();
